export default "__VITE_ASSET__DrXrYJHR__"